import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import SwiperCore from "swiper";
import "swiper/css";
import "swiper/css/pagination";

const testimonialImages = [
  "/testimonial-1.png",
  "/testimonial-2.png",
  "/testimonials-3.png",
  "/testimonials-4.png",
  "/testimonials-5.png",
  "/testimonials-6.png",
];

export default function SwiperTestimonialSection() {
  const swiperRef = useRef<SwiperCore | null>(null);

  return (
    <div className="py-2 px-4  pt-8 lg:pt-20 ">
      <h2 className="text-black text-center  lg:mb-5 font-semibold">
        See what our clients are saying
      </h2>
      <div className="relative  ">
        {/* Left Button */}
        <button
          onClick={() => swiperRef.current?.slidePrev()}
          className="text-3xl  absolute left-[20%] top-[40%] hidden md:block text-black"
          aria-label="Previous"
        >
          &#10094;
        </button>

        {/* Swiper */}
        <Swiper
          onSwiper={(swiper: any) => (swiperRef.current = swiper)}
          modules={[Pagination]}
          spaceBetween={10}
          slidesPerView={1}
          loop={true}
          className="max-w-[500px] w-full"
        >
          {testimonialImages.map((src, index) => (
            <SwiperSlide key={index}>
              <div className="w-full pb-10 flex flex-col items-center justify-center flex-shrink-0">
                <div className="w-full bg-white rounded-[40px]  shadow-md items-center lg:min-h-[250px] min-h-[200px] max-h-[200px] lg:max-h-[250px] flex justify-center p-4">
                  <img
                    src={src}
                    alt={`Testimonial slide ${index + 1}`}
                    className="w-full max-w-2xl rounded-3xl  h-full"
                  />
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Right Button */}
        <button
          onClick={() => swiperRef.current?.slideNext()}
          className="text-3xl absolute top-[40%]  right-[20%] hidden md:block text-black"
          aria-label="Next"
        >
          &#10095;
        </button>
      </div>

      <div className="md:hidden items-center  justify-center gap-2 flex">
        <button
          onClick={() => swiperRef.current?.slidePrev()}
          className="text-2xl  text-black"
          aria-label="Previous"
        >
          &#10094;
        </button>

        <button
          onClick={() => swiperRef.current?.slideNext()}
          className="text-2xl  text-black"
          aria-label="Next"
        >
          &#10095;
        </button>
      </div>
    </div>
  );
}
